module.exports = __webpack_public_path__ + "img/46.2becb342.jpg";